import { Component, OnInit, ViewChild, ElementRef } from '@angular/core'
import { ICON_TYPE, LaunchDialogService } from '@spartacus/storefront'
import { Observable } from 'rxjs'
import { DialogResponse, VS_LAUNCH_CALLER } from '../../config/dialog.config'

@Component({
  standalone: false,
  selector: 'vs-my-favourites-dialog',
  templateUrl: './my-favourites-dialog.component.html',
  styleUrls: ['./my-favourites-dialog.component.scss'],
})
export class MyFavouritesDialogComponent implements OnInit {
  iconTypes = ICON_TYPE
  modalIsOpen = false
  loaded$: Observable<boolean>
  @ViewChild('dialog', { read: ElementRef })
  dialog: ElementRef
  productsEligible: any = []
  productsNotEligible: any = []
  flowIndicator: string = ''

  constructor(protected launchDialogService: LaunchDialogService) {}

  ngOnInit() {
    this.launchDialogService.data$.subscribe((data) => {
      this.productsEligible = data.productsEligible
      this.productsNotEligible = data.productsNotEligible
      this.flowIndicator = data.flowIndicator
      this.loaded$ = data.loaded$
    })
  }

  dismissModal(reason?: any): void {
    const dialogResponse: DialogResponse = {
      type: VS_LAUNCH_CALLER.MY_FAVOURITES,
      reason: reason,
    }
    this.launchDialogService.closeDialog(dialogResponse)
  }

  ngOnDestroy() {
    this.modalIsOpen = false
    this.productsEligible = []
    this.productsNotEligible = []
    this.flowIndicator = ''
  }
}
